import momReducer from './MOM';

export default momReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js